import { updateAppConfig } from '#app/config';
import { defineNuxtPlugin } from '#app/nuxt';
import * as theme from '#build/monospace-ui';
import { reloadNuxtUiEvent } from '#layers/ui/constants/nuxt-ui';

export default defineNuxtPlugin(() => {});

if (import.meta.hot) {
	import.meta.hot.accept((mod) => {
		const themeObject = Object.fromEntries(Object.entries(
			(mod as any).imported.theme,
		).map(
			([key, value]) => ([key, typeof value === 'function' ? value() : value]),
		));

		updateAppConfig({
			ui: themeObject,
		});

		import.meta.hot?.send(reloadNuxtUiEvent);
	});
}

export const imported = {
	theme,
};
